const QUESTIONS = [
  "Who is already helping raise your children?",
  "Who do your children trust?",
  "Who has been doing the work of kin without being named as kin?",
];

const Marquee = () => (
  <div className="relative z-10 bg-ink text-marigold overflow-hidden py-6 border-y-4 border-ink" data-testid="hero-questions-marquee">
    <div className="fr-mq font-mono text-2xl md:text-3xl gap-10 pr-10">
      {[...QUESTIONS, ...QUESTIONS].map((q, i) => (
        <span key={i} className="flex gap-10 whitespace-nowrap">
          <span>{q}</span>
          <span className="text-rose">&#9632;</span>
        </span>
      ))}
    </div>
  </div>
);

export const Hero = () => (
  <header id="top" className="relative isolate overflow-hidden bg-marigold text-ink" data-testid="hero-section">
    <div className="absolute inset-0 fr-drift opacity-20 fr-grnd" aria-hidden="true" />
    <div className="relative z-10 max-w-6xl mx-auto px-6 pt-24 pb-12 md:pt-32">
      <p className="font-mono fr-lbl fr-fade" data-testid="hero-date">Coming 2027 / Zarya Thomas</p>
      <h1 className="font-mono font-bold mt-6 fr-h1" data-testid="hero-title">
        <span className="fr-ln"><span>Family is</span></span>
        <span className="fr-ln"><span>a practice.</span></span>
      </h1>
      <div className="mt-8 grid md:grid-cols-2 gap-8 items-end">
        <div className="fr-fade [animation-delay:.65s]">
          <p className="font-mono fr-lbl">Families, Reimagined</p>
          <p className="mt-2 text-[18px] leading-[1.6] max-w-md" data-testid="hero-subtitle">What If We Raised Our Kids Together?</p>
        </div>
        <a
          href="#join"
          className="fr-fade [animation-delay:.8s] group justify-self-start md:justify-self-end inline-flex items-center gap-3 bg-ink text-marigold px-6 py-4 font-mono fr-lbl transition-transform duration-200 hover:-translate-y-0.5"
          data-testid="hero-cta-button"
        >
          Reserve your free practice <span className="transition-transform duration-200 group-hover:translate-x-1">&rarr;</span>
        </a>
      </div>
    </div>
    <Marquee />
  </header>
);
